<template>
  <div class="pt-4">
    <v-container fluid class="px-15">
      <v-row justify="start" align="start" class="ma-0 mt-5 mb-4">
        <v-col cols="12" class="pa-0">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: #193D6E;">{{ texts.paymentsHistory.title }}</div>
        </v-col>
        <v-col cols="12" class="pa-0">
          <div style="font-family: 'montserrat-regular'; font-size: 14px;">
            {{ texts.paymentsHistory.subTitle }}
          </div>
        </v-col>
      </v-row>
      <v-row class="ma-0 mb-4" style="align-items: center;">
        <v-col cols="12" sm="4" md="2" lg="3" class="pl-0">
          <v-text-field v-model="search" min-width="288" max-width="288" label="Buscar" hide-details style="font-family: 'montserrat-medium'; border-radius: 20px; background-color: white;" append-icon="mdi-magnify" outlined></v-text-field>
        </v-col>
        <v-spacer></v-spacer>
        <v-col style="text-align: end;">
          <v-btn
            color="#0075B8"
            elevation="8"
            class="white--text"
            style="border-radius: 36px; border: 2px solid #0075BB; font-family: 'montserrat-semibold'; text-transform: none;"
            @click="dataXLSX()"
          >
            <v-img class="mr-2" src="../../assets/icons/Vector.svg" style="width: 14px;"></v-img>
            {{ texts.suppliers.download }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="ma-0 mb-4">
        <v-col class="d-flex justify-end py-0">
          <div class="d-flex align-center" style="width: fit-content; background: #BFD7ED; box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15); border-radius: 10px; padding: 15px; border: 1px solid #C5CDD3;">
            <div class="pa-1 mr-3" style="background-color: #ECF6FF; border-radius: 5px;">
              <v-img src="../../assets/icons/trending-up.svg" style="width: 24px;"></v-img>
            </div>
            <div class="mr-1" style="font-family: 'montserrat-semibold';">{{ texts.conversionsHistory.totalCurrencyGain + ": " }}</div>
            <span style="font-family: 'montserrat-bold'" :style="{ color: totalProfit < 0 ? '#0075B8' : '#0075B8'}"> 
              {{ " $" + formatMoney(totalProfit) + " " + ($store.state.sTypeAccount == 'EFEXUSD' ? 'USD' : 'MXN') }}
            </span>
          </div>
        </v-col>
      </v-row>
      <v-data-table :headers="headersForex" hide-default-header :items="items" class="mb-4 d-none d-sm-block" hide-default-footer :items-per-page="-1">
        <template v-slot:header="{ props }">
          <thead style="background-color: #f9fafd;">
            <tr>
              <th class="header__title left">{{ texts.conversions.id }}</th>                                                                                                                                                                                         
              <th class="header__title center">{{ texts.conversions.paymentDate }}</th>
              <th class="header__title center">{{ texts.conversions.recipient }}</th>                                                                                                                                                                                                                               
              <!-- <th class="header__title center">{{ texts.conversions.invoice }}</th> -->
              <!-- <th class="header__title center">{{ texts.conversions.typeTransaction }}</th> -->
              <th class="header__title center">{{ texts.conversions.status }}</th>
              <th class="header__title center">{{ texts.conversions.exchangeRate }}</th>
              <th class="header__title center">{{ texts.conversions.totalAmountUSD }}</th>
              <th class="header__title center">{{ texts.conversions.totalAmountMXN }}</th>
              <th class="header__title center">{{ texts.paymentsHistory.invoices || 'Facturas' }}</th>
              <th class="header__title center">{{ texts.conversions.currencyProfit }}</th>
              <th class="header__title center">{{ texts.conversions.dollarProfit }}</th>
              <th class="header__title right">{{ texts.conversions.actions }}</th>
            </tr>
          </thead>
        </template>
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in items" :key="item.id">
              <td class="table__item">{{ item.iTrackingId }}</td>
              <td class="table__item">{{ formatDate(item.created_at) }}</td>
              <td class="table__item">
                <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif">
                  {{ item.payment_recipient.sName }}
                </h4>
              </td>
              <!-- <td class="table__item">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on" style="text-overflow: ellipsis; max-width: 100px; overflow: hidden;">
                      {{ item.invoice ? item.invoice : "-" }}
                    </div>
                  </template>
                  <span>{{ item.invoice ? item.invoice : "-" }}</span> 
                </v-tooltip>
              </td> -->
              <!-- <td class="table__item">
                <v-chip v-if="item.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3'" color="#D61518" style="background-color: #FDF0F5 !important;" outlined>
                  {{ "Forward" }}
                </v-chip>
                <v-chip v-else-if="item.sTransactionType == 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a'" color="#2397C7" style="background-color: #F0F8FE !important;" outlined>
                  {{ "Spot" }}
                </v-chip>
                <v-chip v-else-if="item.sTransactionType == '1e337607-b37b-4491-83b0-6383a45f9481'" color="#0EAB5D" style="background-color: #EFFAF2 !important;" outlined>
                  {{ "Withdrawal" }}
                </v-chip>
                <v-chip v-else-if="item.sTransactionType == 'f588edfa-73d4-4365-a240-90a3339dfdb2'" color="#603CB5" style="background-color: #F4F0F8 !important;" outlined>
                  {{ "Collect" }}
                </v-chip>
                <v-chip v-else-if="item.sTransactionType == 'ea9d350f-f00b-4763-90db-72e7af54dc73'" color="#E8B238" style="background-color: #FDF8EB !important;" outlined>
                  {{ "Pay Now" }}
                </v-chip>
                <v-chip v-else-if="item.sTransactionType == '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf'" color="#FB0075" style="background-color: #FDEBEB !important;" outlined>
                  {{ "Window spot" }}
                </v-chip>
                <h4 v-else>
                  {{ "-" }}
                </h4>
              </td> -->
              <td class="table__item">
                <v-chip :color="setStatusColor(item.status?.sName)" outlined style="text-wrap: nowrap !important;">
                  {{ item.status?.sName ? texts.status[item.status?.sName] : item.status?.sName }}
                </v-chip>
              </td>
              <td class="table__item">{{  item.dRate ? "$ " + formatMoney(item.dRate) + " MXN" : "-" }}</td>
              <td class="table__item">{{ item.dPaymentAmount ? "$ " + formatMoney(item.dPaymentAmount) + " " + item.sCurrency  : "-" }}</td>
              <td class="table__item">{{ item.dDescAmount ? "$ " + formatMoney(item.dDescAmount) + " " + item.sDestCurrency : "-" }}</td>
              <td class="table__item">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on" style="text-overflow: ellipsis; max-width: 100px; overflow: hidden;">
                      {{ item.invoices && item.invoices.length ? item.invoices.join(', ') : '-' }}
                    </div>
                  </template>
                  <span>{{ item.invoices && item.invoices.length ? item.invoices.join(', ') : '-' }}</span>
                </v-tooltip>
              </td>
              <td class="table__item" :style="item.dCurrencyGain >= 0 ? 'color: #4CAF50;' : 'color: #E74C3C;'">{{ formatProfitByAccount(item) }}</td>
              <td class="table__item" :style="item.dProfitPercentage >= 0 ? 'color: #4CAF50;' : 'color: #E74C3C;'">{{ item.dProfitPercentage ? formatMoney(item.dProfitPercentage) + "%" : "-" }}</td>
              <td class="table__item">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="goDetail(item)" v-bind="attrs" v-on="on" icon color="black">
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ texts.conversionsHistory.viewDetail }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="openReceipt(item)"
                      v-bind="attrs"
                      v-on="on"
                      icon
                      color="black"
                      :disabled="item.status?.sName !== 'COMPLETED' && item.status?.sName !== 'DEPOSITED'"
                    >
                      <v-icon>mdi-receipt-text</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ "Open Receipt" }}</span> 
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="openCep(item)"
                      v-bind="attrs"
                      v-on="on"
                      icon
                      color="black"
                      :disabled="item.status?.sName !== 'COMPLETED' && item.status?.sName !== 'DEPOSITED'"
                    >
                      <v-icon>mdi-receipt-text</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ "Open CEP" }}</span> 
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
      <v-data-table class="d-sm-none d-block" hide-default-header :items="items" hide-default-footer :items-per-page="-1">
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr class="table__item" style="display: flex; flex-direction: column;" v-for="item in items" :key="item.id">
              <td class="table__item__mobile">
                <div>{{ texts.conversions.id }}</div>
                <div>{{ item.iTrackingId }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.conversions.paymentDate }}</div>
                <div>{{ formatDate(item.created_at) }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.conversions.recipient }}</div>
                <div>
                  <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif">
                    {{ item.payment_recipient.sName }}
                  </h4>
                </div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.conversions.invoice }}</div>
                <div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on" style="text-overflow: ellipsis; max-width: 100px; overflow: hidden;">
                        {{ item.invoice ? item.invoice : "-" }}
                      </div>
                    </template>
                    <span>{{ item.invoice ? item.invoice : "-" }}</span> 
                  </v-tooltip>
                </div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.conversions.typeTransaction }}</div>
                <div>
                  <v-chip v-if="item.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3'" color="#D61518" style="background-color: #FDF0F5 !important;" outlined>
                    {{ "Forward" }}
                  </v-chip>
                  <v-chip v-else-if="item.sTransactionType == 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a'" color="#2397C7" style="background-color: #F0F8FE !important;" outlined>
                    {{ "Spot" }}
                  </v-chip>
                  <v-chip v-else-if="item.sTransactionType == '1e337607-b37b-4491-83b0-6383a45f9481'" color="#0EAB5D" style="background-color: #EFFAF2 !important;" outlined>
                    {{ "Withdrawal" }}
                  </v-chip>
                  <v-chip v-else-if="item.sTransactionType == 'f588edfa-73d4-4365-a240-90a3339dfdb2'" color="#603CB5" style="background-color: #F4F0F8 !important;" outlined>
                    {{ "Collect" }}
                  </v-chip>
                  <v-chip v-else-if="item.sTransactionType == 'ea9d350f-f00b-4763-90db-72e7af54dc73'" color="#E8B238" style="background-color: #FDF8EB !important;" outlined>
                    {{ "Pay Now" }}
                  </v-chip>
                  <v-chip v-else-if="item.sTransactionType == '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf'" color="#FB0075" style="background-color: #FDEBEB !important;" outlined>
                    {{ "Window spot" }}
                  </v-chip>
                  <h4 v-else>
                    {{ "-" }}
                  </h4>
                </div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.conversions.status }}</div>
                <div>
                  <v-chip :color="setStatusColor(item.status?.sName)" outlined style="text-wrap: nowrap !important;">
                    {{ item.status?.sName ? texts.status[item.status?.sName] : item.status?.sName }}
                  </v-chip>
                </div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.conversions.totalAmountUSD }}</div>
                <div>{{ item.dAmount ? "$ " + formatMoney(item.dAmount) + " " + item.sCurrency  : "-"  }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.conversions.totalAmountMXN }}</div>
                <div>{{ item.dDescAmount ? "$ " + formatMoney(item.dDescAmount) + " " + item.sDestCurrency : "-" }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.conversions.exchangeRate }}</div>
                <div>{{ item.dRate ? "$ " + formatMoney(item.dRate) + " MXN" : "-"  }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.paymentsHistory.invoices || 'Facturas' }}</div>
                <div>{{ item.invoices && item.invoices.length ? item.invoices.join(', ') : '-' }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.conversions.currencyProfit }}</div>
                <div :style="item.dCurrencyGain >= 0 ? 'color: #4CAF50;' : 'color: #E74C3C;'">{{ formatProfitByAccount(item) }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.conversions.dollarProfit }}</div>
                <div :style="item.dProfitPercentage >= 0 ? 'color: #4CAF50;' : 'color: #E74C3C;'">{{ item.dProfitPercentage ? formatMoney(item.dProfitPercentage) + "%" : "-"  }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.conversions.actions }}</div>
                <div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="goDetail(item)" v-bind="attrs" v-on="on" icon color="black">
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ texts.conversionsHistory.viewDetail }}</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="openReceipt(item)"
                        v-bind="attrs"
                        v-on="on"
                        icon
                        color="black"
                        :disabled="item.status?.sName !== 'COMPLETED' && item.status?.sName !== 'DEPOSITED'"
                      >
                        <v-icon>mdi-receipt-text</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ "Open Receipt" }}</span> 
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="openCep(item)"
                        v-bind="attrs"
                        v-on="on"
                        icon
                        color="black"
                        :disabled="item.status?.sName !== 'COMPLETED' && item.status?.sName !== 'DEPOSITED'"
                      >
                        <v-icon>mdi-receipt-text</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ "Open CEP" }}</span> 
                  </v-tooltip>
                </div>
              </td>
            </tr>
            <v-divider></v-divider>
          </tbody>
        </template>
      </v-data-table>
      <!-- Paginación server-side -->
      <v-row class="ma-0 mt-4 mb-2" align="center" justify="space-between">
        <v-col cols="auto" class="py-0">
          <div style="display: flex; align-items: center; gap: 8px;">
            <span style="font-family: 'montserrat-regular'; font-size: 13px; color: #506172;">Registros por página:</span>
            <v-select
              v-model="iItemsPerPage"
              :items="pageSizeOptions"
              item-text="text"
              item-value="value"
              dense
              outlined
              hide-details
              style="max-width: 110px; font-family: 'montserrat-regular';"
            ></v-select>
          </div>
        </v-col>
        <v-col cols="auto" class="py-0">
          <v-pagination
            v-model="iCurrentPage"
            :length="iNumPages"
            :total-visible="7"
            color="#0075B8"
          ></v-pagination>
        </v-col>
      </v-row>
    </v-container>

    <!-- Dialogo de detalle de pago -->
    <v-dialog v-model="dialogPaymentDetail" max-width="1400px" scrollable>
      <v-card>
        <v-card-text class="pa-0">
          <PaymentDetail
            v-if="selectedPaymentId"
            :key="selectedPaymentId"
            :s-payment-id="selectedPaymentId"
            @back="closePaymentDetail"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import PaymentDetail from "./PaymentDetail.vue";

export default {
  name: "DashboardView",
  components: {
    PaymentDetail,
  },
  data() {
    return {
      nameXLSX: "HistorialPagos.xlsx",
      texts: "",
      search: "",
      loading: true,
      drawer: null,
      actualCurrency: "0",
      actualCurrencyMxn: "0",
      referenceCurrency: "0",
      isLoading: false,
      isRegisterEfex: true,
      exchangeRateData: [],
      selected: [],
      exchangeRateDataPaid: [],
      exchangeRateDataSeparate: [],
      balanceMxn: "0",
      balanceUsd: "0",
      balance: "0",
      itemsRaw: [],
      itemss: [],
      tab: 0,
      contacts: [],
      itemsSelected: [],
      itemsSelectedForwards: [],
      isForwardRateCalculated: false,
      bSelectedAll: false,
      dialogAddFoundss: false,
      dialogSendPay: false,
      dialogAddFounds: false,
      dataAddFounds: {},
      dialogCreate: false,
      dialogPay: false,
      editableData: {},
      selectedCard: null,
      totalUsd: 0,
      totalProfit: 0,
      selectedMenuItem: "dashboard",
      contactData: {
        sName: "",
        sEmail: "",
        sBank_name: "",
        sAccount_number: "",
        sEntity_business: "COMPANY"
      },
      isForwardsActive: false,
      showCreateProvider: false,
      isResponsive: false,
      screenWidth: 0,
      bLoading: false,
      isDeferredPayment: false,
      stepper: false,
      e1: 1,
      timerCount: 30,
      headersForex: [
        this.selectLanguage === 'en' ? { text: "Id", value: "iTrackingId", align: "center", sortable: false} : { text: "Id", value: "iTrackingId", align: "center", sortable: false},
        this.selectLanguage === 'en' ? { text: "Payment date", value: "created_at", align: "center"} : { text: "Fecha de pago", value: "created_at", align: "center"},
        this.selectLanguage === 'en' ? { text: "Recipient", value: "sName", align: "center"} : { text: "Destinatario", value: "sName", align: "center"},
        this.selectLanguage === 'en' ? {text: 'Invoice', value: 'invoice', align: 'center', sortable: false} : {text: 'Factura', value: 'invoice', align: 'center', sortable: false},
        this.selectLanguage === 'en' ? { text: "Type Transaction", value: "type", align: "center"} : { text: "Tipo de transacción", value: "type", align: "center"},
        this.selectLanguage === 'en' ? { text: "Status", value: "status_sName", align: "center"} : { text: "Estado", value: "status_sName", align: "center"},
        this.selectLanguage === 'en' ? { text: "Total amount MXN", value: "dDescAmount", align: "center"} : { text: "Monto total MXN", value: "dDescAmount", align: "center"},
        this.selectLanguage === 'en' ? { text: "Total amount USD", value: "dAmount", align: "center"} : { text: "Monto total USD", value: "dAmount", align: "center"},
        this.selectLanguage === 'en' ? { text: "Exchange rate", value: "dRate", align: "center"} : { text: "Tasa de cambio", value: "dRate", align: "center"},
        this.selectLanguage === 'en' ? { text: "Currency profit (%)", value: "percentProfit", align: "center", sortable: false} : { text: "Beneficio de moneda (%)", value: "percentProfit", align: "center", sortable: false}, 
        this.selectLanguage === 'en' ? { text: "Currency gain",value: "dollarProfit", align: "center", sortable: false} : { text: "Beneficio de moneda",value: "dollarProfit", align: "center", sortable: false},
        this.selectLanguage === 'en' ? { text: "Actions", value: "actions", align: "center", sortable: false } : { text: "Acciones", value: "actions", align: "center", sortable: false },
      ],
      timerId: null,
      dataEfex: {},
      exchangeRateAdjustments: [],
      exchangeRatesStateForwards: [],
      isPayMxn: false,
      bSelectedAllSeparate: false,
      dialogEditProfileActive: false,
      dialogPaymentDetail: false,
      selectedPaymentId: null,
      iCurrentPage: 1,
      iItemsPerPage: 10,
      iNumPages: 1,
      iTotal: 0,
      pageSizeOptions: [
        { text: '10', value: 10 },
        { text: '25', value: 25 },
        { text: '50', value: 50 },
        { text: '100', value: 100 },
        { text: 'Todos', value: '' }
      ],
      isForwards: false,
      isForwardsPayment: false,
      userName: "",
      modalCurrency: 0,
      sections: [
        {
          icon: "mdi mdi-view-dashboard",
          value: "operation",
          title: "Operaciones",
          items: [
            {
              icon: "mdi mdi-view-dashboard",
              value: "dashboard",
              title: "Dashboard",
              disabled: false
            },
            {
              icon: "mdi-file-document",
              value: "history",
              title: "Seguimiento de facturas",
              disabled: false
            },
            {
              icon: "mdi-forward",
              value: "activeForwards",
              title: "Forwards activos",
              disabled: false
            }
          ]
        },
        {
          icon: "mdi-history",
          value: "history",
          title: "Historial",
          items: [
            {
              icon: "mdi-file-document",
              value: "exchangeRate",
              title: "Historial de conversiones",
              disabled: true
            },
            {
              icon: "mdi-file-document",
              value: "history",
              title: "Historial de pagos",
              disabled: false
            }
          ]
        },
        {
          icon: "mdi-wallet",
          value: "wallets",
          title: "Wallets",
          items: [
            {
              icon: "mdi-account-group",
              value: "suppliers",
              title: "Proveedores",
              disabled: true
            },
            {
              icon: "mdi-account-group",
              value: "suppliers",
              title: "Estado de cuenta",
              disabled: true
            }
          ]
        }
      ],
      miniVariant: true,
      expandOnHover: false,
      registerFields: [
        { model: "sBankName", type: "text", label: "sBankName" },
        { model: "sAccountNumber", type: "text", label: "sAccountNumber" },
        { model: "sRoutingNumber", type: "text", label: "sRoutingNumber" }
      ],
      transactions: [],
      invoices: []
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  methods: {
    tabStyle(tabIndex) {
      return {
        color: this.tab === tabIndex ? "#f0be43" : "#506172",
        fontSize: "16px",
        fontWeight: "600",
        width: "200px",
        lineHeight: "24px",
        fontFamily: "montserrat-bold"
      };
    },
    handleResize: function () {
      if (window.innerWidth >= 960) {
        this.screenWidth = 30;
      } else {
        this.screenWidth = 100;
      }

      this.isResponsive = window.innerWidth < 960;
    },
    getPaymentsHistory() {
      this.isLoading = true;
      DB.get(`${URI}/api/v1/${this.selectLanguage}/payments/`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        },
        params: {
          sSearch: this.search || '',
          iPageNumber: this.iCurrentPage,
          iItemsPerPage: this.iItemsPerPage
        }
      })
        .then((response) => {
          const payments = response?.data?.payments || [];
          this.iNumPages = response?.data?.iNumPages || 1;
          this.iTotal = response?.data?.iTotal || 0;
          this.iCurrentPage = response?.data?.iCurrentPage || 1;
          this.itemsRaw = payments.map((payment) => {
            let invoices = [];
            let pay = [];
            const transactions = payment.transaction || [];
            if (transactions.length > 0) {
              if (transactions[0].transaction) {
                payment.sTransactionType =
                  transactions[0].transaction.sTransactionType;
                payment.dExchangeRate = transactions[0].transaction.dExchangeRate;
                payment.dExchangeRateReal =
                  transactions[0].transaction.dDesAmount /
                  transactions[0].transaction.dAmount;
                if (payment.totalActualCost) {
                  payment.dAmount = payment.totalActualCost;
                } else {
                  payment.dAmount = payment.dDescAmount / payment.dExchangeRateReal;
                }
              }
            }

            const invoicePayments = Array.isArray(
              payment.invoice_payments_relationship
            )
              ? payment.invoice_payments_relationship
              : [];
            if (invoicePayments.length > 0) {
              invoicePayments.forEach((invoiceRel) => {
                const invoiceData =
                  invoiceRel?.invoice || invoiceRel?.invoiceMX || null;
                if (!invoiceData) {
                  return;
                }

                const invoiceNumber =
                  invoiceData.sInvoice || invoiceData.sInvoiceMXId || "";
                const invoicePurchaseDate =
                  invoiceData.dPurchaseDate || invoiceData.dCreatedAt || "";

                if (invoiceNumber) {
                  invoices.push(invoiceNumber);
                }
                if (invoicePurchaseDate) {
                  pay.push(invoicePurchaseDate);
                }
              });
            }

            payment.invoice = invoices.join(", ");
            payment.pay = pay.join(", ");
            return payment;
          });
          this.totalProfit = response?.data?.totalProfit || 0;
        })
        .catch((error) => {
          if (error?.response?.data?.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(
            error?.response?.data?.message ||
              "No se pudo cargar el historial de pagos",
            error?.response?.status || 500
          );
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getInvoices() {
      DB.get(
        `${URI}/api/v1/${this.selectLanguage}/invoices/?exchangeRateToday=${this.actualCurrency}`,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      ).then((response) => {
        this.invoices = response.data.invoices;
      });
    },
    getTransactions() {
      DB.get(`${URI}/api/v1/${this.selectLanguage}/transactions/`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      }).then((response) => {
        this.transactions = response.data.transactions;
      });
    },
    formatMoney: function (value) {
      let multiplied = value * 100;
      let rounded = Math.round(multiplied);
      let formattedNumber = rounded / 100;
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(formattedNumber);
    },
    getAccountTypeNormalized(accountType) {
      return String(accountType || "").toUpperCase();
    },
    getProfitCurrency(accountType) {
      const normalizedType = this.getAccountTypeNormalized(
        accountType || this.$store.state.sTypeAccount
      );
      return normalizedType === "EFEXMXN"
        ? "MXN"
        : "USD";
    },
    formatProfitByAccount(item) {
      if (!item?.dCurrencyGain || item.dCurrencyGain === 0) {
        return "-";
      }
      return `$ ${this.formatMoney(item.dCurrencyGain)} ${this.getProfitCurrency(item?.sAccountType)}`;
    },
    getExchangeRate: function () {
      this.itemsRaw = [];

      DB.get(
        `${URI}/api/v1/${this.selectLanguage}/exchange-rate/?exchangeRateToday=${this.actualCurrency}`,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      )
        .then((response) => {
          this.isForwardsActive = response.data.isForwardsActive;
          this.userName = response.data.user;
          this.isRegisterEfex = response.data.registerInEfex;
          this.exchangeRateDataPaid =
            response.data.exchangeRate.exchangeRatesStatePaid;
          this.exchangeRateData =
            response.data.exchangeRate.exchangeRatesStateToPay;
          this.exchangeRateDataSeparate =
            response.data.exchangeRate.exchangeRatesStateSeparated;
          this.exchangeRatesStateForwards =
            response.data.exchangeRate.exchangeRatesStateForwards;
          this.balanceMxn = response.data.balance.balanceMxn;
          this.balanceUsd = response.data.balance.balanceUsd;
          this.exchangeRateAdjustments = response.data.exchangeRateAdjustments;
          this.balance =
            parseFloat(this.balanceMxn) / parseFloat(this.actualCurrency) +
            parseFloat(this.balanceUsd);
          this.balance = this.balance.toString();

          // this.totalUsd = 0;

          // this.itemsSelected.forEach((item) => {
          //   item.dTotalUsdToday = parseFloat(item.dTotalUsdToday);
          //   this.totalUsd += item.dTotalUsdToday;
          // });

          this.mixSuccess(response.data.message);
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        })
        .finally(() => {
          this.getContacts();
        });
    },
    getContacts: function () {
      DB.get(`${URI}/api/v1/${this.selectLanguage}/contacts-wallet/`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
        .then((response) => {
          this.contacts = response.data.contacts;
          this.contacts.push({
            id: 0,
            name: "Crear nuevo contacto"
          });
        })
        .catch((error) => {
          // Handle error if needed
        });
    },
    openModalAddFounds() {},
    openModalSendPay() {
      this.dialogSendPay = true;
    },
    openModalAddFoundss() {
      this.dialogAddFoundss = true;

      const payload = {
        amount: 100
      };

      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/exchange-rate/addFounds`,
        payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      )
        .then((response) => {
          this.dataAddFounds = response.data.account;
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    closeModalAddFounds() {
      this.dialogAddFounds = false;
    },
    toggleAll: function (checked) {
      this.exchangeRateData.forEach((item) => {
        if (
          item.statusName !== "WAITING_FOR_DEPOSIT" ||
          item.statusName !== "PROCESSING"
        ) {
          item.bSelected = checked;
        }
      });
    },
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM D, YYYY");
      return formattedDate;
    },
    // formatMoney: function (money) {
    //   return FORMAT_MONEY(money);
    // },
    resetForm() {
      this.editableData = {
        dPurchaseDate: "",
        sProvider: "",
        sInvoiceNumber: "",
        dDescAmount: "",
        iCreditPeriod: "",
        dInvoiceExchangeRateProtection: ""
      };
    },
    openModalCreate() {
      this.dialogCreate = true;
      this.resetForm();
    },
    validateForm: function () {
      return true;
    },
    saveChanges: function () {
      this.bLoading = true;
      let newdPurchaseDate = this.formatDateToSend(
        this.editableData.dPurchaseDate
      );

      const payload = {
        dPurchaseDate: newdPurchaseDate.toString(),
        sProvider: this.editableData.sProvider,
        sInvoiceNumber: this.editableData.sInvoiceNumber,
        dDescAmount: parseFloat(this.editableData.dDescAmount),
        iCreditPeriod: parseInt(this.editableData.iCreditPeriod),
        createContact: this.showCreateProvider,
        contactData: this.contactData,
        dInvoiceExchangeRateProtection:
          this.editableData.dInvoiceExchangeRateProtection
      };
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.sToken}`
        }
      };

      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/exchange-rate/`,
        payload,
        config
      )
        .then((response) => {
          this.bLoading = false;
          this.dialogCreate = false;
          this.mixSuccess(response.data.message);
          this.getExchangeRate();
          this.closeDialog();
        })
        .catch((error) => {
          this.bLoading = false;
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    formatDateToSend: function (date) {
      let newDate = new Date(date);
      let day = newDate.getDate() + 1;
      let month = newDate.getMonth() + 1;
      let year = newDate.getFullYear();
      return `${year}-${month}-${day}`;
    },
    changebSelectedAll: function () {
      this.bSelectedAll = !this.bSelectedAll;
    },
    closeModalCreate() {
      this.dialogCreate = false;
      this.showCreateProvider = false;
      this.contactData = {
        sName: "",
        sEmail: "",
        sBank_name: "",
        sAccount_number: "",
        sEntity_business: "COMPANY"
      };
    },
    sendToPayNow: function () {
      this.isDeferredPayment = false;
      this.sendToPay();
    },
    sendToPay: function () {
      this.itemsSelected = this.exchangeRateData.filter(
        (item) => item.bSelected
      );
      if (this.itemsSelected.length > 0) {
        this.stepper = true;
        this.itemsSelected.forEach((item) => {
          item.dTotalUsdToday = parseFloat(item.dTotalUsdToday);
          this.totalUsd += item.dTotalUsdToday;
        });
      } else {
        this.mixError("No hay elementos seleccionados", 400);
      }
    },
    actualizarE1(nuevoValor) {
      this.e1 = nuevoValor;
    },
    closeModalPay() {
      this.dialogPay = false;
      this.totalUsd = 0;
      this.e1 = 1;
    },
    sendToPayNowMxn: function () {
      this.isDeferredPayment = false;
      this.isPayMxn = true;
      this.itemsSelected = this.exchangeRateDataSeparate.filter(
        (item) => item.bSelected
      );
      this.itemsSelected.forEach((item) => {
        item.dTotalUsdToday = parseFloat(item.dTotalUsdToday);
        this.totalUsd += item.dTotalUsdToday;
      });

      if (this.itemsSelected.length > 0) {
        this.dialogPay = true;
      } else {
        this.mixError("No hay elementos seleccionados", 400);
      }
    },
    sendToPayNowForwards: function () {
      this.isPayMxn = true;
      this.itemsSelected = this.exchangeRatesStateForwards.filter(
        (item) => item.bSelected
      );
      this.itemsSelected.forEach((item) => {
        item.dTotalUsdToday = parseFloat(item.dTotalUsdToday);
        this.totalUsd += item.dTotalUsdToday;
      });

      if (this.itemsSelected.length > 0) {
        this.sendPayEfex();
      } else {
        this.mixError("No hay elementos seleccionados", 400);
      }
    },
    closeModalStepper() {
      this.stepper = false;
      this.totalUsd = 0;
      this.e1 = 1;
      this.isForwards = false;
      this.isForwardsPayment = false;
      //this.getActualCurrency();
    },
    changeDeferredPayment() {
      this.isDeferredPayment = !this.isDeferredPayment;
    },
    changePayMxn() {
      this.isPayMxn = !this.isPayMxn;
    },
    sendPayEfex: function () {
      this.bLoading = true;

      if (this.isPayMxn) {
        this.totalUsd = this.totalUsd * this.actualCurrency;
      }

      const payload = {
        pays: this.itemsSelected,
        referenceCurrency: this.referenceCurrency,
        actualCurrency: this.actualCurrency,
        isDeferredPayment: this.isDeferredPayment,
        isPayMxn: this.isPayMxn,
        totalUsd: this.totalUsd
      };

      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/exchange-rate/sendPayment/`,
        payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      )
        .then((response) => {
          if (!response.data.status) {
            this.mixError(response.data.message, 400);
          } else {
            this.mixSuccess(response.data.message);
          }
          this.bLoading = false;
          this.dialogPay = false;
          this.defferedPayment = false;
          this.getExchangeRate();
          this.totalUsd = 0;
          this.isPayMxn = false;
        })
        .catch((error) => {
          this.bLoading = false;
          this.mixError(error.data.message, error.response.status);
        });
    },
    closePaymentDetail() {
      this.dialogPaymentDetail = false;
      this.selectedPaymentId = null;
    },
    goDetail(item) {
      this.selectedPaymentId = item.sPaymentId;
      this.dialogPaymentDetail = true;
      // this.loading = true;
      // const payload = {
      //   sPaymentId: item.sPaymentId
      // };

      // DB.post(
      //   `${URI}/api/v1/${this.selectLanguage}/payments/paymentReceipt`,
      //   payload,
      //   {
      //     headers: {
      //       Authorization: this.$store.state.sToken
      //         ? `Bearer ${this.$store.state.sToken}`
      //         : ""
      //     }
      //   }
      // )
      //   .then((response) => {
      //     if (response.data && response.data.payment) {
      //       let base64 = response.data.paymentReceipt.data;

      //       const base64Pattern =
      //         /^data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+);base64,/;
      //       if (base64Pattern.test(base64)) {
      //         base64 = base64.split(",")[1];
      //       }

      //       try {
      //         const binaryString = window.atob(base64);
      //         const bytes = new Uint8Array(binaryString.length);
      //         for (let i = 0; i < binaryString.length; i++) {
      //           bytes[i] = binaryString.charCodeAt(i);
      //         }
      //         const blob = new Blob([bytes], { type: "application/pdf" });

      //         this.loading = false;
      //         const url = URL.createObjectURL(blob);
      //         window.open(url, "_blank");
      //       } catch (e) {
      //         this.loading = false;
      //       }
      //     } else {
      //       this.loading = false;
      //     }
      //   })
      //   .catch((error) => {
      //     this.mixError(error.response.data.message, error.response.status);
      //   });
    },
    downloadReceipt(item) {
      this.loading = true;
      const payload = {
        sPaymentId: item.sPaymentId
      };

      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/payments/paymentReceipt`,
        payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      )
        .then((response) => {
          if (response.data && response.data.payment) {
            let base64 = response.data.paymentReceipt.data;

            const base64Pattern =
              /^data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+);base64,/;
            if (base64Pattern.test(base64)) {
              base64 = base64.split(",")[1];
            }

            try {
              const binaryString = window.atob(base64);
              const bytes = new Uint8Array(binaryString.length);
              for (let i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
              }
              const blob = new Blob([bytes], { type: "application/pdf" });

              this.loading = false;
              const url = URL.createObjectURL(blob);
              window.open(url, "_blank");
            } catch (e) {
              this.loading = false;
            }
          } else {
            this.loading = false;
          }
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    openReceipt(item) {
      this.loading = true;
      const payload = {
        sPaymentId: item.sPaymentId
      };

      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/payments/openReceipt`, payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          },
          responseType: 'blob'
        }
      )
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${item.payment_recipient.sName + (item.invoice ? "_" + item.invoice : "")}.pdf`;
        link.click();
      })
      .catch((error) => {
        this.mixError(
          error?.response?.data?.message || "No se pudo descargar el archivo",
          error?.response?.status || 500
        );
      })
      .finally(() => {
        this.loading = false;
      });
    },
    openCep(item) {
      this.loading = true;
      const payload = {
        sPaymentId: item.sPaymentId
      };

      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/payments/paymentCep`, payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      )
      .then((response) => {
        const url = response.data.paymentCep;
        if (url) {
          window.open(url, "_blank");
        } else {
          this.mixError("No se recibió una URL válida del servidor.", 400);
        }
      })
      .catch((error) => {
        this.mixError(error.response.data.message, error.response.status);
      })
      .finally(() => {
        this.loading = false;
      });
    },
    sendSeparateEfex: function () {
      this.bLoading = true;
      const payload = {
        exchangeRateId: this.itemsSelected,
        rateUuid: this.referenceCurrency,
        rateInt: this.actualCurrency
      };

      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/exchange-rate/separateExchangeRate/`,
        payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      )
        .then((response) => {
          if (!response.data.status) {
            this.mixError(response.data.message);
          } else {
            this.mixSuccess(response.data.message);
          }
          this.bLoading = false;
          this.dialogSeparate = false;
          this.getExchangeRate();
        })
        .catch((error) => {
          this.bLoading = false;
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    toggleAllSeparated: function (checked) {
      this.exchangeRateDataSeparate.forEach((item) => {
        item.bSelected = checked;
      });
    },
    toggleAllForwards: function (checked) {
      this.exchangeRatesStateForwards.forEach((item) => {
        this.$set(item, "bSelected", checked);
      });
    },
    createSubAccount(data) {
      const payload = {
        sBank_name: data.sBankName,
        sAccount_number: data.sAccountNumber,
        sRouting_number: data.sRoutingNumber,
        clabe: data.clabe,
        sBank_mxn_account: data.sBankMxnAccount
      };

      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.sToken}`
        }
      };

      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/sub-account/`,
        payload,
        config
      )
        .then((response) => {
          this.mixSuccess(response.data.message);
          this.getExchangeRate();
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    openModal(item) {
      this.totalUsd = 0;
      this.selectedItem = item;
      this.editableData = { ...this.selectedItem };
      this.dialogEditProfileActive = true;
    },
    closeDialog() {
      this.dialogEditProfileActive = false;
    },
    backStep() {
      this.e1 = 1;
    },
    updateExchangeRate: function () {
      this.bLoading = true;
      let newdPurchaseDate = this.formatDateToSend(
        this.editableData.dPurchaseDate
      );
      const payload = {
        sExchangeRateId: this.selectedItem.sExchangeRateId,
        dPurchaseDate: newdPurchaseDate.toString(),
        sProvider: this.editableData.sProvider,
        sInvoiceNumber: this.editableData.sInvoiceNumber,
        dDescAmount: parseFloat(this.editableData.dDescAmount),
        iCreditPeriod: parseInt(this.editableData.iCreditPeriod),
        dInvoiceExchangeRateProtection:
          this.editableData.dInvoiceExchangeRateProtection,
        dAmountAdjustment: parseFloat(this.editableData.dAmountAdjustment),
        sCurrencyAdjustment: "MXN"
      };

      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.sToken}`
        }
      };

      DB.put(
        `${URI}/api/v1/${this.selectLanguage}/exchange-rate/${this.selectedItem.sExchangeRateId}`,
        payload,
        config
      )
        .then((response) => {
          this.bLoading = false;
          this.dialogEditProfileActive = false;
          this.mixSuccess(response.data.message);
          this.getExchangeRate();
          this.closeDialog();
        })
        .catch((error) => {
          this.bLoading = false;
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    changeForwards: function (value) {
      this.isForwards = value;
    },
    getForwards: function () {
      this.bLoading = true;
      const payload = {
        pays: this.itemsSelected,
        referenceCurrency: this.referenceCurrency,
        reverse: true
      };
      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/exchange-rate/getRateForwards/`,
        payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      )
        .then((response) => {
          if (!response.data.status) {
            this.mixError(response.data.message, 400);
            this.bLoading = false;
            this.isForwardsPayment = false;
          } else {
            this.mixSuccess(response.data.message);
            this.bLoading = false;
            this.isForwardsPayment = true;
            this.isForwardRateCalculated =
              response.data.isForwardRateCalculated;
            this.itemsSelected = response.data.responsePaysEfex;
          }
          this.getExchangeRate();
        })
        .catch((error) => {
          this.bLoading = false;
          this.isForwardsPayment = false;
          this.mixError(error.data.message, 400);
        });
    },
    sendForwardPayment: function () {
      const payload = {
        pays: this.itemsSelected
      };
      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/exchange-rate/sendPayForward/`,
        payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      )
        .then((response) => {
          if (!response.data.status) {
            this.mixError(response.data.message, 400);
          } else {
            this.mixSuccess(response.data.message);
          }
          this.bLoading = false;
          this.stepper = false;
          this.defferedPayment = false;
          this.getExchangeRate();
          this.totalUsd = 0;
          this.isForwardsPayment = false;
          this.isPayMxn = false;
        })
        .catch((error) => {
          this.bLoading = false;
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    changeModalCurrency: function (value) {
      this.modalCurrency = value;
    },
    updateTotalUsd: function (value) {
      this.totalUsd = value;
    },
    setStatusColor: function (status) {
      if (status === "COMPLETED" || status === "DEPOSITED") {
        return "green";
      } else if(status === "PENDING_TO_PROCESS"){
        return "blue";
      } else if(status === "PENDING_TO_DEPOSIT"){
        return "blue";
      } else if(status === "REJECTED"){
        return "red";
      }
       else {
        return "gray";
      }
    },
    dataXLSX() {
      try {
        let data = this.items.map((item) => {
          return {
            "Id": item.iTrackingId ? item.iTrackingId : "",
            "Fecha de pago": item.created_at ? this.formatDate(item.created_at) : "",
            "Destinatario": item.payment_recipient?.sName || "N/A",
            "Estatus": item.status?.sName || "",
            "Tipo de cambio": item.dRate ? (item.dRate ? parseFloat(item.dRate) : "") : "-",
            "Monto origen": item.dPaymentAmount ? parseFloat(item.dPaymentAmount) : "",
            "Monto destino": item.dDescAmount ? parseFloat(item.dDescAmount) : "",
            "currency origen": item.sCurrency ? item.sCurrency : "",
            "currency dest": item.sDestCurrency ? item.sDestCurrency : "",
            "Profit (%)": item.dProfitPercentage ? Math.round(parseFloat(item.dProfitPercentage) * 100) / 100 : "",
            "Profit ($)": item.dCurrencyGain ? Math.round(parseFloat(item.dCurrencyGain) * 100) / 100 : "",
          };
        });
        const worksheet = XLSX.utils.json_to_sheet(data);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Hoja1");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

        const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        saveAs(blob, this.nameXLSX);
        this.success = true;
        this.msgSuccess = "Descargando documento";
      } catch (error) {
        this.error = true;
        this.codeError = "CSV_NO_DATA";
      }
    },
    updateHeaders () {
      this.headersForex =  [
        { text: this.texts.conversions.id, value: "iTrackingId", align: "center", sortable: false},
        { text: this.texts.conversions.paymentDate, value: "created_at", align: "center"},
        { text: this.texts.conversions.recipient, value: "sName", align: "center"},
        { text: this.texts.conversions.invoice, value: "invoice", align: "center", sortable: false},
        { text: this.texts.conversions.typeTransaction, value: "type", align: "center"},
        { text: this.texts.conversions.status, value: "status_sName", align: "center"},
        { text: this.texts.conversions.totalAmountMXN, value: "dDescAmount", align: "center"},
        { text: this.texts.conversions.totalAmountUSD, value: "dAmount", align: "center"},
        { text: this.texts.conversions.exchangeRate, value: "dRate", align: "center"},
        { text: this.texts.conversions.currencyProfit, value: "percentProfit", align: "center", sortable: false},
        { text: this.texts.conversions.dollarProfit, value: "dollarProfit", align: "center", sortable: false},
        { text: this.texts.conversions.actions, value: "actions", align: "center", sortable: false }
      ]    
    }
  },
  beforeMount() {
    this.texts = FILE.takeRate[this.selectLanguage];
    this.getPaymentsHistory();
    this.updateHeaders();
  },
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    },
    totalProfitCurrency() {
      return this.getProfitCurrency(this.$store.state.sTypeAccount);
    },
    items() {
      // El filtrado y paginación se hacen en el servidor.
      // Este computed devuelve directamente la página recibida del backend.
      return this.itemsRaw;
    },
    formattedTime() {
      const minutes = Math.floor(this.timerCount / 60);
      const seconds = this.timerCount % 60;
      return `${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
    }
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.takeRate[this.selectLanguage];
      }
      this.updateHeaders();
    },
    "editableData.sProvider": function (newValue) {
      this.showCreateProvider = newValue === 0;
    },
    search: function () {
      clearTimeout(this._searchDebounce);
      this._searchDebounce = setTimeout(() => {
        // Si ya estamos en page 1, el watcher de iCurrentPage no dispara → llamar directo.
        // Si no, setear a 1 deja que ese watcher haga el fetch.
        if (this.iCurrentPage !== 1) {
          this.iCurrentPage = 1;
        } else {
          this.getPaymentsHistory();
        }
      }, 400);
    },
    iCurrentPage: function () {
      this.getPaymentsHistory();
    },
    iItemsPerPage: function () {
      if (this.iCurrentPage !== 1) {
        this.iCurrentPage = 1; // el watcher de iCurrentPage llama getPaymentsHistory
      } else {
        this.getPaymentsHistory();
      }
    }
  }
};
</script>

<style scoped>
.bg-container {
  width: 100%;
  background: #fff;
  opacity: 1;
  height: 100%;
}
.full-height {
  height: 100vh;
  width: 100%;
  overflow-y: auto;
}
.active {
  background-color: #f0f0f0;
}
/* .active-section .v-list-item__icon {
  color: yellow !important;
  background-color: yellow !important;
}

.active-section .v-list-item__title {
  background-color: yellow !important;
} */

.active-item {
  background-color: #f5f7f9 !important;
}
.button-add {
  background: transparent linear-gradient(258deg, #ffc556 0%, #fffc81 100%) 0%
    0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0px;
  color: #283c4d;
  text-transform: initial;
}
.v-tabs-slider {
  background: #f0be43 !important;
  height: 3px;
  color: #f0be43 !important;
  border-radius: 100px;
}

.card-main {
  width: 40vh;
  height: 16vh;
  position: relative;
  background: white;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  overflow: hidden;
}

.card-content {
  position: absolute;
  top: 19px;
  left: 16px;
}

.circle-content {
  text-align: center;
  color: white;
  margin: auto;
}

.btn-custom {
  color: #f0be43;
}

.card-title {
  color: #302e2e;
  font-size: 16px;
  font-family: montserrat-bold;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 8px;
}

.card-info,
.balance-title {
  color: #777777;
  font-size: 10px;
  font-weight: 400;
  line-height: 20px;
}

.card-mxn {
  width: 200px;
  color: #f0be43;
  font-size: 24px;
  font-family: Mons;
  font-weight: 700;
  line-height: 36px;
  font-style: normal;
  word-wrap: break-word;
}

.container-width,
.header-container {
  max-width: 1280px;
  margin: auto;
}

.title-medium {
  font-family: "montserrat-semibold";
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.headline-medium {
  font-family: "montserrat-semibold";
  font-size: 28px;
  font-weight: 600;
  line-height: 36px;
  text-align: left;
}

.body-large {
  font-family: "montserrat-regular";
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
}

.blocked-amount {
  font-family: "montserrat-regular";
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.blocked-amount-2 {
  color: #302e2e;
  font-family: "montserrat-regular";
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
}

.circle-sheet {
  width: 200px;
  height: 200px;
  padding-left: 17px;
  padding-right: 62px;
  overflow: hidden;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: inline-flex;
  position: absolute;
  right: -60px;
  top: -20px;
}

.usd-balance {
  color: #666565;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.content-balance {
  color: #302e2e;
  font-family: "montserrat-medium", sans-serif;
  font-size: 22px;
  font-weight: 600;
  line-height: 28px;
  text-align: left;
  padding-top: 10px;
}

.h5 {
  font-family: "montserrat-bold";
  font-size: 24px;
  line-height: 36px;
  text-align: left;
}

.buttonAddFounds {
  text-align: center;
  color: #f0be43;
  font-size: 16px;
  font-family: "montserrat-semibold";
  font-weight: 600;
  line-height: 24px;
  text-transform: capitalize;
  word-wrap: break-word;
}

.modalTextAddFounds {
  color: #302e2e;
  font-family: "Montserrat-Regular", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.table th {
  background-color: #f2f2f4;
  /* border: 1px solid #ccc; */
}

@media (max-width: 1150px) {
  .card-title {
    font-size: 14px;
  }

  .card-mxn {
    font-size: 20px;
  }

  .usd-balance {
    font-size: 12px;
  }

  .content-balance {
    font-size: 18px;
  }

  .blocked-amount {
    font-size: 12px;
  }

  .blocked-amount-2 {
    font-size: 14px;
  }

  .buttonAddFounds {
    font-size: 14px;
  }

  .circle-sheet {
    display: none;
  }
}

@media (max-width: 1250px) {
  .circle-sheet {
    width: 155px;
    height: 170px;
    padding-left: 17px;
    padding-right: 40px;
    right: -50px;
    top: -5px;
  }
}
</style>
